import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'Our Team', href: '/players' },
    { name: 'Schedule', href: '/schedule' },
    { name: 'Live Scores', href: '/live' },
    { name: 'Kids Camp', href: '/kids-camp' },
    { name: 'Standings', href: 'https://sites.google.com/site/pinetreebaseballleague/team-statistics' },
    { name: '2026 Sponsors', href: '/sponsors' },
    { name: 'Sponsorship Info', href: '/sponsorship-info' },
    { name: 'Donate', href: '/donate' },
    { name: 'Shop', href: '/shop' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="px-4 sm:px-6 lg:px-8 py-6">
        <div className="bg-gradient-to-r from-cardinal/60 via-cardinal/70 to-cardinal/60 backdrop-blur-sm rounded-2xl shadow-xl max-w-7xl mx-auto border border-white/10">
          <div className="px-4 sm:px-6">
            <div className="flex items-center justify-between h-16">
              {/* Logo */}
              <div className="flex-shrink-0">
                <Link to="/" className="flex items-center">
                  <Logo />
                </Link>
              </div>
              
              {/* Desktop Navigation - Centered */}
              <div className="hidden xl:flex flex-1 justify-center px-4 overflow-x-auto">
                <nav className="flex items-center space-x-1 flex-nowrap">
                  {navItems.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      target={item.href.startsWith('http') ? '_blank' : undefined}
                      rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className={`whitespace-nowrap text-white hover:text-gray-200 px-2 lg:px-3 py-2 text-xs lg:text-sm font-medium transition-all relative group rounded-lg hover:bg-white/5 flex-shrink-0 ${
                        location.pathname === item.href ? 'bg-white/10' : ''
                      }`}
                    >
                      {item.name}
                      <span className="absolute inset-x-0 -bottom-0.5 h-0.5 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform origin-center"></span>
                    </a>
                  ))}
                </nav>
              </div>

              {/* Contact Button */}
              <div className="hidden xl:block flex-shrink-0">
                <Link
                  to="/contact"
                  className="inline-flex items-center px-3 lg:px-5 py-2.5 border border-white/20 text-xs lg:text-sm font-medium rounded-xl text-white bg-white/5 hover:bg-white/10 transition-all hover:border-white/30 hover:shadow-lg hover:shadow-white/5 whitespace-nowrap"
                >
                  Contact
                </Link>
              </div>

              {/* Mobile menu button */}
              <div className="xl:hidden">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="inline-flex items-center justify-center p-2 rounded-lg text-white hover:text-gray-200 hover:bg-white/5 transition-colors focus:outline-none"
                >
                  {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="xl:hidden bg-gradient-to-r from-cardinal/70 via-cardinal/80 to-cardinal/70 backdrop-blur-sm rounded-b-2xl border-t border-white/10">
              <div className="px-4 pt-2 pb-3 space-y-1">
                {navItems.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className={`text-white hover:text-gray-200 block px-3 py-2 text-base font-medium rounded-lg hover:bg-white/5 transition-colors ${
                      location.pathname === item.href ? 'bg-white/10' : ''
                    }`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.name}
                  </a>
                ))}
                <Link
                  to="/contact"
                  className="text-white hover:text-gray-200 block px-3 py-2 text-base font-medium border-t border-white/10 mt-2 pt-2 rounded-lg hover:bg-white/5 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;